<template>
    <a-card :bordered='false'>
     <a-radio-group class="m-b-15" v-model:value="search.time_type" button-style="solid" @change="selectDay">
        <a-radio-button value="">全部</a-radio-button>
        <a-radio-button :value="1">近7天</a-radio-button>
        <a-radio-button :value="2">近30天</a-radio-button>
        <a-radio-button :value="3">自定义时间</a-radio-button>
      </a-radio-group>
       <a-range-picker class="m-l-10" v-if="search.time_type==3" @change="onChange" valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' :disabledDate="disabledDate"/><br/>
      <a-radio-group class="m-b-15" v-model:value="search.datatype" button-style="solid" @change="selectOrdertype">
        <a-radio-button  value="all">全部订单</a-radio-button>
        <a-radio-button  value="delivery">待发货</a-radio-button>
        <a-radio-button  value="receipt">待收货</a-radio-button>
        <a-radio-button  value="complete">已完成</a-radio-button>
      </a-radio-group>
      <a-form layout='inline'>
           <a-form-item>
                <a-input-group compact :style="{width:'360px'}">
                   <a-select v-model:value="search.key_type" style="width: 30%" >
                     <a-select-option value="order_sn">订单号</a-select-option>
                     <a-select-option value="clerk_name">导购员</a-select-option>
                   </a-select>
                   <a-input style="width: 70%" v-model:value="search.keyword"  placeholder="请输入关键词进行搜索"/>
              </a-input-group>
           </a-form-item>
           <a-form-item label="所属门店" class="s_po_re">
                <a-input v-model:value="search.store_name" readonly placeholder="请选择门店"></a-input>
               <CloseCircleOutlined  v-if="search.store_name" class="CloseCircleOutlined s_shou" @click="search.store_name='';search.store_id=''"/>
           </a-form-item>
            <a-form-item >
                <a-button type="primary" @click="showStore=true">选择</a-button>
            </a-form-item>
            <!-- <a-form-item label="下单时间">
                <a-range-picker v-model:value="time" valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' @change="changeTime" />
           </a-form-item> -->
            <a-form-item>
              <a-button type="primary" htmlType='submit' @click="search.page=1;pagination.current=1;getGuideOrderList()">搜索</a-button>
               <a-button type="primary" ghost htmlType='submit' class="m-l-15" v-has:exportGuideTable="()=>{exportTable()}">导出</a-button>
            </a-form-item>
      </a-form>
       <a-table :pagination='pagination' :loading='listLoading' bordered rowKey='id' :columns='columns' class="tableFixBox m-t-20" :scroll="{x:true}" :data-source='list' @change="changePage">
           <template v-slot:good="{record}">
                 <div >
                   <a-card-meta>
                     <template #avatar>
                       <img :src="info.picdomain+'/'+(record.gift_image)" alt="" style="width:50px;height:50px">
                     </template>
                     <template #description>
                       <p class="s_omit2" style="width: 320px;">{{record.gift_name}}</p>
      
                     </template>
                   </a-card-meta>
                 </div>
           </template>
           <template #action="{record}">
           <a-dropdown>
            <a class="ant-dropdown-link"> 操作
              <DownOutlined />
            </a>
            <template v-slot:overlay>
              <a-menu>
                <a-menu-item>
                  <a href="javascript:;" v-has:integralShoppingDetail="()=>{$router.push('/order/order_list/order_detail?id='+record.order_no)}">详情</a>
                </a-menu-item>
                 <a-menu-item v-if="record.order_status==1">
                  <a href="javascript:;"  v-has:deliverGoods="()=>{deliverGoods(record)}">发货</a>
                </a-menu-item>
                 <a-menu-item v-if="( record.order_status==1 || record.order_status==2)">
                  <a href="javascript:;"  v-has:orderEditAddress="()=>getAddress(record)">修改地址</a>
                </a-menu-item>
                 <a-menu-item  v-if="record.order_status != 4">
                  <a href="javascript:;" v-has:orderEditRemarks='()=>getRemarks(record)'>编辑备注</a>
                </a-menu-item>
              </a-menu>
            </template>
            </a-dropdown>
           </template>
       </a-table>
       <!-- 所属门店 -->
       <a-modal  :keyboard="false" centered title="选择门店" v-model:visible="showStore" :width='1200' :footer="null" destroyOnClose>
         <selectStore v-on:select="select" :hiddenHead='true' :selectList='storeList'></selectStore>
       </a-modal>
        <a-modal  :keyboard="false" title="订单备注" centered v-model:visible="showRemarks" :confirm-loading="confirmLoading" @ok="eidtRemarks" destroyOnClose>
      <a-textarea v-model:value="orderRemarks" placeholder="请输入订单备注内容" :rows="4" />
    </a-modal>
    <a-modal  :keyboard="false" title="修改收货地址" :width='600' centered :footer="null" v-model:visible="showAddress" destroyOnClose>
      <addressChange :addressData='addressData' :type='true' v-on:submitdeliver='submitAddress'></addressChange>
    </a-modal>
     <!-- 发货 -->
    <a-modal  :keyboard="false" title="发货" :width='1000' centered :footer="null" v-model:visible="showDeliver" destroyOnClose>
      <deliverForem :deliverData='deliverData' :type='3' :isInsteadShip='1' v-on:submitdeliver='submitdeliver'></deliverForem>
    </a-modal>
    <!-- <a-modal  :keyboard="false" title="物流信息" :width='800' centered :footer="null" v-model:visible="showLogistics" destroyOnClose>
      <logisticsDetails :data='logisticsData'></logisticsDetails>
    </a-modal> -->
    </a-card>
</template>

<script>
import {
  DownOutlined,CloseCircleOutlined
} from "@ant-design/icons-vue";
import { reactive, toRefs,ref, onMounted,inject } from 'vue';
import store from "@/store";
import {guideOrderList,guideOrderDelivery,guideOrderReceiveAddress,guideOrderStoreRemark} from '@/api/guide';
import { iscode } from '../../../utils/app';
import { useTime } from "@/hooks/utils/useTime";
import { message } from "ant-design-vue";
const form = {
   time_type:'',
   key_type:'order_sn',
   keyword:'',
   store_name:'',
   store_id:'',
   start_time:'',
   end_time:'',
   limit:10,
   page:1,
   datatype:'all'
}
const columns = [
    {
        title: "订单号",
        dataIndex: "order_no",
        key: "order_no",
    },
    {
        title: "订单商品",
        dataIndex: "gift_name",
        key: "gift_name",
         slots: { customRender: "good" },
    },
    {
        title: "导购员",
        dataIndex: "clerk_name",
        key: "clerk_name",
    },
     {
        title: "所属门店",
        dataIndex: "store_name",
        key: "store_name",
    },
    {
        title: "支付方式",
        dataIndex: "pay_type_text",
        key: "pay_type_text",
    },
    {
        title: "状态",
        dataIndex: "order_status_text",
        key: "order_status_text",
    },
     {
        title: "下单时间",
        dataIndex: "create_time",
        key: "create_time",
    },
     {
        title: "操作",
        dataIndex: "action",
        slots: { customRender: "action" },
        fixed:'right',
        width:120
    },
]
export default{
    components:{DownOutlined,CloseCircleOutlined},
    setup(){
      const { dateTargets, typeToStartEnd } = useTime();
          const $route = inject("$route");
        const momentTime=inject('momentTime')
        const search = ref({...form})
        const state = reactive({
              time:[],
              storeList:[],
              showStore:false,
              listLoading:false,
              showDeliver:false,
              showAddress:false,
              deliverType: 1,
              deliverData: {},
              addressData:{},
              goodData:{},
              orderRemarks:'',
              showRemarks:false,
              pagination:{ 
                 total:0,
                 current:1,
                 pageSize:10,
                 defaultPageSize:10,
                 showSizeChanger:true,
                 pageSizeOptions:['10', '20', '30', '40', '50'], 
                 showQuickJumper:true, 
                 showTotal:(total)=> `共 ${total} 条`,
               },
               list:[],
                confirmLoading:false,
                info: store.state.user.info,
                 disabledDate: (current)=> {
                   // return  current && current > momentTime().subtract(0, 'days').endOf('day')
                   if (search.value.start_time) {
                     let offsetDays= 86400000 * 89;
                     let selectV = momentTime(search.value.start_time, 'YYYY-MM-DD').valueOf()
                     return (current > momentTime().subtract(0, 'days').endOf('day') || current >momentTime(new Date(selectV + offsetDays), "YYYY-MM-DD")) || current < momentTime(new Date(selectV - offsetDays), "YYYY-MM-DD")
                   } else {
                      return current && current > momentTime().subtract(0, 'days').endOf('day');
                   }
                 },
        })

        const methods= {
            changeTime(e){
                state.time = e;
                search.value.start_time = e[0];
                search.value.end_time = e[1];
            },
            select(data){
                search.value.store_name = data.store_name || '';
                search.value.store_id = data.id;
                state.storeList = [data]
                state.showStore = false;
            },
            deliverGoods(record){
              state.goodData = record;
              const {buy_num,gift_image,gift_name} = record;
              state.deliverData = {
                detail: [{
                    product_image:gift_image,
                    product_name:gift_name,
                    buy_num:buy_num
                }],
                extract: {
                   extract_name:record.extract.name,
                   extract_phone:record.extract.phone,
                   detail:record.area
                },
              };
            state.showDeliver = true;
            },

         //发货
         async submitdeliver(data) {
           const hide = message.loading("正在加载中...", 0);
           let res = await guideOrderDelivery({...data,order_no:state.goodData.order_no}).then(res=>res.data)
            setTimeout(hide);
           if(iscode(res,true)){
              state.showDeliver = false; 
              methods.getGuideOrderList()
           }

           },
              //获取订单地址
             async getAddress(record){
                  state.addressData = {
                     name:record.extract.name,
                     phone:record.extract.phone,
                     detail:record.extract.detail,
                     province_id:record.extract.province_id,
                     city_id: record.extract.city_id,
                     region_id:record.extract.region_id,
                     city_texts:'',
                     id:record.extract.id
                   }
                     state.showAddress = true;


              },
                 //获取备注
                async  getRemarks(record){
                   state.goodData = record;
                   state.orderRemarks = record.store_remark || '';
                   state.showRemarks = true;
                   
                 },
                async getGuideOrderList(){
                  state.listLoading = true;
                  state.list = [];
                   let res = await guideOrderList({...search.value}).then(res=>res.data);
                   state.listLoading = false;
                     if(iscode(res)){
                        state.list = res.data.data || [];
                        state.pagination.total = res.data.total;
                     }else {
                       message.error(res.msg);
                     }
                },
                // 选择订单筛选时间
                selectDay(e){
                  var value=e.target.value
                    switch(value){
                      case "":
                           search.value.end_time = ''
                          search.value.start_time = ''
                      break;
                      case 1:
                          search.value.end_time = typeToStartEnd("1").end_time;
                          search.value.start_time = typeToStartEnd("7").start_time;
                      break;
                      case 2:
                          search.value.end_time = typeToStartEnd("1").end_time;
                          search.value.start_time = typeToStartEnd("30").start_time;
                      break;
                    }
                    if(value==3) return
                    search.value.page = 1;
                   methods.getGuideOrderList()
                },
                selectOrdertype(e){
                     search.value.datatype = e.target.value;
                     search.value.page = 1;
                     methods.getGuideOrderList()
                },
                 // 时间筛选
               onChange(e){
                 search.value.start_time = e[0]
                 search.value.end_time = e[1];
                 search.value.page = 1;
                  methods.getGuideOrderList()
               },
               changePage(e){
                 state.pagination.current = e.current;
                 state.pagination.pageSize = e.pageSize;
                 search.value.page = e.current;
                 search.value.limit = e.pageSize;
                 methods.getGuideOrderList()
             },
             //确认修改地址
             async submitAddress(){
               const hide = message.loading("正在加载中...", 0);
               let res = await guideOrderReceiveAddress({...state.addressData}).then(res=>res.data)
               setTimeout(hide);
               if(iscode(res,true)){
                 state.showAddress = false;
                 methods.getGuideOrderList()
               }
             },
                 //修改备注
            async eidtRemarks(){
              // state.confirmLoading = true;
               const hide = message.loading("正在加载中...", 0);
                let remarksData = {
                 order_no:state.goodData.order_no,
                 store_remark: state.orderRemarks
               }
              let res = await guideOrderStoreRemark({...remarksData}).then((res) => res.data).catch((error) => error);
               setTimeout(hide);
              if (iscode(res)) {
                state.showRemarks = false;
                methods.getGuideOrderList()
              } else {
                message.error(res.msg);
              }
              // state.confirmLoading = false;
            },
           async exportTable(){
                 const hide = message.loading('正在加载中...', 0);
                 let result = await guideOrderList({...search.value,excel:1}).then(res=>res.data).catch(error=>error);
                 if(iscode(result,true)){
                   window.open(result.data.action)
                 }
                 setTimeout(hide);
            }
        }

        onMounted(()=>{
           methods.getGuideOrderList()
        })

        return {
            ...toRefs(state),
            search,
            columns,
            ...methods
        }
    }
}
</script>

<style lang="less" scoped>
 .CloseCircleOutlined{
    position: absolute;
    top:50%;
    right:8px;
    transform: translateY(-50%);
}
</style>
